function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import classnames from "classnames";
import CarouselPrev from "static/svg/carousel-prev.svg";
import CarouselNext from "static/svg/carousel-next.svg";
import ImageWithParagraphGridComponent from "segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-component";
import { XS, XS_L } from "constants/sizes";
import AssetComponent from "components/core/asset/asset-component";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_ARROW_CLICKED, TAB_CLICKED } from "constants/bigbrain-event-types";
import UseCaseProductBanner from "segments/desktop/tabs/layouts/use-cases-tabs/use-case-product-banner/use-case-product-banner";
import constants from "segments/desktop/header/layouts/components/basic-header/constants";
import { scrollIntoViewWithOffset } from "utils/dom";
import { StyledUseCasesTabsDesktopComponent } from "./use-cases-tabs-desktop-component.scss";
import { imagesProps } from "../default-props";
const CAROUSEL_LEFT_SWIPE = "left";
const CAROUSEL_RIGHT_SWIPE = "right";
const VISIBILITY_SENSOR_OFFSET = -100;
const DEFAULT_AUTO_PLAY_SPEED = 10000;
const UseCasesTabsDesktopComponent = (props)=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const [carouselRef, setCarouselRef] = useState(null);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const ref = useRef(null);
    const { autoplay, autoplaySpeed, tabs, theme, buttonsColor, scrollWhenButtonClicked, replacementItemRenderer, hideArrows, disableDraggable } = props;
    const defaultItemRenderer = (tab)=>{
        const { asset, images, banner = {} } = (tab === null || tab === void 0 ? void 0 : tab.tabContent) || {};
        const tabImages = images || imagesProps;
        const imagesWithoutTopic = tabImages === null || tabImages === void 0 ? void 0 : tabImages.map((image)=>_object_spread_props(_object_spread({}, image), {
                fullParagraph: _object_spread_props(_object_spread({}, image.fullParagraph), {
                    topic: {}
                })
            }));
        return /*#__PURE__*/ _jsxs("div", {
            className: "use-case-tab-content",
            children: [
                asset && /*#__PURE__*/ _jsx("div", {
                    className: "use-case-tab-asset",
                    children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "use-case-tab-paragraphs",
                    children: /*#__PURE__*/ _jsx(ImageWithParagraphGridComponent, {
                        images: imagesWithoutTopic,
                        titleSize: XS_L,
                        textSize: XS,
                        textAlign: "center"
                    })
                }),
                (banner === null || banner === void 0 ? void 0 : banner.productType) && /*#__PURE__*/ _jsx(UseCaseProductBanner, _object_spread({
                    theme: theme
                }, banner))
            ]
        });
    };
    const navItemRenderer = (tab, index)=>{
        const onNavItemClick = ()=>{
            setSelectedTab(index);
            if (scrollWhenButtonClicked) {
                scrollIntoViewWithOffset(ref, constants.BASIC_HEADER_HEIGHT);
            }
            trackEvent(TAB_CLICKED, {
                kind: tab === null || tab === void 0 ? void 0 : tab.tabLabel,
                info1: index
            });
            carouselRef.slickGoTo(index);
        };
        const selected = selectedTab === index;
        return /*#__PURE__*/ _jsx("span", {
            className: classnames("use-cases-tab-nav-button-wrapper", {
                selected
            }),
            onClick: onNavItemClick,
            onKeyDown: generateOnKeyDownHandler(onNavItemClick),
            role: "tab",
            "aria-selected": selected,
            tabIndex: 0,
            children: tab.tabLabel
        }, index);
    };
    const PrevArrow = (arrowProps)=>{
        const { className, style, onClick } = arrowProps;
        const onPrevArrowClick = ()=>{
            trackEvent(CAROUSEL_ARROW_CLICKED, {
                kind: tabs === null || tabs === void 0 ? void 0 : tabs[selectedTab].tabLabel,
                info1: selectedTab,
                info3: "prev"
            });
            onClick();
        };
        return /*#__PURE__*/ _jsx("button", {
            className: classnames(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            tabIndex: 0,
            onKeyDown: generateOnKeyDownHandler(onPrevArrowClick),
            children: /*#__PURE__*/ _jsx(CarouselPrev, {})
        });
    };
    const NextArrow = (arrowProps)=>{
        const { className, style, onClick } = arrowProps;
        const onNextArrowClick = ()=>{
            trackEvent(CAROUSEL_ARROW_CLICKED, {
                kind: tabs === null || tabs === void 0 ? void 0 : tabs[selectedTab].tabLabel,
                info1: selectedTab,
                info3: "next"
            });
            onClick();
        };
        return /*#__PURE__*/ _jsx("button", {
            className: classnames(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onKeyDown: generateOnKeyDownHandler(onClick),
            children: /*#__PURE__*/ _jsx(CarouselNext, {})
        });
    };
    const itemRenderer = replacementItemRenderer ? replacementItemRenderer : defaultItemRenderer;
    const carouselProps = {
        items: tabs,
        itemRenderer,
        defaultIndex: 0,
        slidesToShow: 1,
        autoplay,
        autoplaySpeed: parseInt(autoplaySpeed) || DEFAULT_AUTO_PLAY_SPEED,
        centerMode: false,
        infinite: true,
        onRefSet: setCarouselRef,
        arrows: true,
        nextArrow: !hideArrows && /*#__PURE__*/ _jsx(NextArrow, {}),
        prevArrow: !hideArrows && /*#__PURE__*/ _jsx(PrevArrow, {}),
        draggable: !disableDraggable
    };
    const onCarouselChange = (current)=>{
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
        }
    };
    const onCarouselSwipe = (direction)=>{
        let newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
    };
    const onVisibilityChange = (isVisible)=>{
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsxs(StyledUseCasesTabsDesktopComponent, {
            className: classnames("use-cases-tabs-component", buttonsColor),
            ref: ref,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "use-cases-tabs-navigation",
                    role: "tablist",
                    "aria-label": "Use cases tabs",
                    children: tabs.map((tab, index)=>navItemRenderer(tab, index))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: (current)=>onCarouselChange(current),
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
export default UseCasesTabsDesktopComponent;
